import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import userReducer from './reducers/userReducer';
import themeReducer from './reducers/themeReducer';
import ratingTemplateReducer from './reducers/ratingTemplatesReducer';
import coachReducer from './reducers/coachReducer';
import profileVerificationReducer from './reducers/profileVerificationReducer';
import loadingReducer from './reducers/loadingReducer';
import companyReducer from './reducers/companyReducer';
import questionLevelsReducer from './reducers/questionLevelsReducer';

const rootReducer = combineReducers({
  userReducer,
  themeReducer,
  ratingTemplateReducer,
  coachReducer,
  profileVerificationReducer,
  loadingReducer,
  companyReducer,
  questionLevelsReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
